import * as SharedAcross from '../utilities/SharedAcross';

function App(props) {

  var type = props.type;
  var value = props.value;
  var organicChanges = props.organicChanges;
  var path = props.path;
  var currentList = props.currentList;
  var clickSelectRowFormula = props.clickSelectRowFormula;

  function regenerateObj(type){
    if (type.t === 'UInteger' && type.sp === 'dateTime'){
      return Math.floor(new Date()/1000);
    }else if (type.t === 'UInteger' || type.t === 'Integer' || type.t === 'Decimal'){
      return '1';
    }else if (type.t === 'Address'){
      return '0x';
    }else if (type.t === 'Object'){
      var obj = {};
      type.c.forEach((aC, index)=>{
        var p = regenerateObj(aC.t);
        obj[aC.keyOnce] = p;
      })
      return obj;
    }else if (type.t === 'ListType'){
      return {s:{}}
    }else if (type.t === 'Boolean'){
      return 1;
    }else if (type.t === 'Text String'){
      if (type.sp === 'image'){
        return 'https://cdn.pixabay.com/photo/2022/03/12/07/39/astronaut-7063568_1280.png'
      }
      return 'Text';
    }else{
      console.warn(type);
    }

  }
  function clickUseDirect(e){
    var n = regenerateObj(type);
    var changes = [{t:'w',w:path,n}];
    organicChanges(changes);
  }

  function clickUseFormula(e){
    var changes = [{t:'w',w:path,n:genericFormula(type, value, currentList)}];
    organicChanges(changes);
    clickSelectRowFormula(e);

  }
  if (value && value.t === 'formula'){
    return <div onClick={clickUseDirect} style={{cursor:'pointer'}}><center>[Use Direct Response Instead]</center></div>

  }else{
    return <div onClick={clickUseFormula} style={{cursor:'pointer'}}><center>[Use Formula Instead]</center></div>

  }
//      
}

//
function genericFormula(type, value, currentList){


  var y = {};

  function getOX(type){
    var o; var x;

    if (type.t === 'UInteger' && type.sp === 'dateTime'){
      o = {t:'dt',v:value}; x = [o];
    }else if (type.t === 'UInteger'){
      if (SharedAcross.isPositiveIntegerOrZeroText(value)){
      }else{
        value = '1';
      }
      o = {t:'ui',v:value}; x = [o];
    }else if (type.t === 'Integer'){
      if (SharedAcross.isIntegerText(value)){
      }else{
        value = '1';
      }
      o = {t:'i',v:value}; x = [o];
    }else if (type.t === 'Text String'){
      o = {t:'s',v:value}; x = [o];
    }else if (type.t === 'Enum'){
      o = {t:'en',v:type.v,i:value}; x = [o];
    }else if (type.t === 'Decimal'){
      if (SharedAcross.isDecimalText(value)){
      }else{
        value = '1';
      }
      o = {t:'dc',v:value}; x = [o];
    }else if (type.t === 'Boolean'){
      o = {t:'f',i:113,v:[]}; x = [{t:'f',v:113}];
      // o = {t:'f',i:8,v:[]}; x = [{t:'f',v:8}];
    }else if (type.t === 'ListType'){
      if (type.c && type.c.t === 'Object' && type.c.c.length === 2 && type.c.c[0].n === 'date'  && type.c.c[1].n === 'value' ){
        o = {"t":"f","i":104,"v":[{"t":"coin","v":"bitcoin"},{"t":"curr","v":"usd"},{"t":"ui","v":"30"}]};
        x = [{"t":"f","v":104},{"t":"g","v":"c0_4ccf773a"},{"t":"g","v":"c0_e90c4ea6"},{"t":"g","v":"c0_ce6ddab0"}];
        y = {"c0_4ccf773a":{"x":[{"t":"coin","v":"bitcoin"}]},c0_e90c4ea6:{"x":[{"t":"curr","v":"usd"}]},c0_ce6ddab0:{"x":[{"t":"ui","v":"30"}]}};
      }else{
        o = {t: 'f',i:60,v:[]}; x = [{t:'f',v:60}];
      }
    // }else if (type.t === 'Mapping'){
    //   o = {t: 'f',i:60,v:[]}; x = [{t:'f',v:60}];
    }else if (type.t === 'Date Time'){
      o = {t:'f',i:43,v:[]}; x = [{t:'f',v:43}];
    }else if (type.t === 'Address'){
      o = {t:'f',i:117,v:[]}; x = [{t:'f',v:117}];
    }else if (type.t === 'Object'){
      o = {t:'f',i:60,v:[]}; x = [{t:'f',v:60}]; 
    }else if (type.t === 'ScEvent'){
      o = {t:'f',i:60,v:[]}; x = [{t:'f',v:60}]; 
    }else{
      console.warn(type);
    }
    return {o, x};
  }


  var ox = getOX(type);
  var o = ox.o;
  var x = ox.x;

  return {t:'formula', x, o, r:type,y};

}
export default App;
